import { render } from "./PointAdjustmentView.vue?vue&type=template&id=3d779a39"
import script from "./PointAdjustmentView.vue?vue&type=script&lang=js"
export * from "./PointAdjustmentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__